export default "__VITE_ASSET__138a993a__"